// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"945cef13","657":"7f803470","787":"ea0bc743"}[chunkId] + ".chunk.js";
};